import './bookmarked-travels.scss';

import AjaxLoad from '../../utilities/js/ajax-load';
import { createElementFromHTML } from '../../utilities/js/helper';
import { Pagination } from '../../components/pagination/pagination';

class BookmarkedTravels {
    constructor (element) {
        this.$bookmarkedTravels = element;
        this.$results = element.querySelector('[data-bookmark-travels="results"]');
        this.$resultsWrapper = element.querySelector('[data-bookmark-travels="results-wrapper"]');
        this.$form = element.querySelector('[data-bookmark-travels="form"]');
        this.$sortSelect = this.$form.querySelector('select[name="sort"]');
        this.$bookmarkFilterCount = this.$bookmarkedTravels.querySelector('[data-bookmark-filter="count"]');
        this.$bookmarkFilterClear = this.$bookmarkedTravels.querySelector('[data-bookmark-filter="clear"]');
        this.$$switchFields = this.$bookmarkedTravels.querySelectorAll('[data-bookmark-filter="switch-field"]');
        this.$bookmarkPreviewSwitch = this.$bookmarkedTravels.querySelector('[data-bookmark-filter-switch="isPreview"]');
        this.ajaxActive = false;
        this.ajaxUrl = this.$form.getAttribute('action');
        this.loader = null;
        this.tripCodes = [];
        this.showTravelPreviewOnly = false;

        this.pagination = new Pagination(this.$results, {
            paginationAttr: '[data-bookmark-travels="pagination"]',
            selectPaginationAttr: '[data-bookmark-travels="select-pagination"]'
        });
    }

    initialize () {
        this.getTripCodes();

        if (this.tripCodes.length > 0) {
            this.$bookmarkedTravels.classList.remove('is--empty');
            this.setEvents();
            this.checkBeforeSubmit();
        }
    }

    getTripCodes () {
        if (window.bookmark.localBookmarks) {
            this.tripCodes = window.bookmark.localBookmarks.map(entry => entry.tripCode);
            this.$bookmarkFilterCount.textContent = this.tripCodes.length;
        }
    }

    setEvents () {
        this.$sortSelect.addEventListener('change', () => {
            this.checkBeforeSubmit();
        });

        this.$$switchFields.forEach($switch => {
            const $switchCheckbox = $switch.querySelector('[data-bookmark-filter="switch-field-checkbox"]');
            const $switchToggle = $switch.querySelector('[data-bookmark-filter="switch-field-toggle"]');

            $switchCheckbox?.addEventListener('change', () => {
                if ($switchCheckbox.name === 'isPreview') {
                    this.showTravelPreviewOnly = $switchCheckbox.checked;
                }

                this.checkBeforeSubmit();
            });

            $switchToggle?.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    $switchCheckbox.checked = !$switchCheckbox.checked;
                }
            });
        });

        window.addEventListener('bookmark.removed', () => {
            this.getTripCodes();

            if (this.tripCodes.length > 0) {
                this.checkBeforeSubmit();
            } else {
                window.bookmark.clearBookmarks();
                window.location.reload();
            }
        });

        this.$bookmarkFilterClear.addEventListener('click', () => {
            window.bookmark.clearBookmarks();
            window.location.reload();
        });
    }

    checkBeforeSubmit () {
        if (this.ajaxActive === false) {
            this.ajaxActive = true;
            this.loader = createElementFromHTML(window.OPTIONS.loader);
            this.$resultsWrapper.prepend(this.loader);
            this.$resultsWrapper.classList.remove('is--visible');
            this.sendRequest();
        } else {
            console.log('Please wait.....Ajax is running');
        }
    }

    sendRequest () {
        const jsonData = {
            sort: this.$sortSelect.value,
            tripCodes: this.tripCodes,
            showTravelPreviewOnly: this.showTravelPreviewOnly,
            token: this.$form.querySelector('[id="bookmark-list"]').value
        };

        this.result = new AjaxLoad(this.ajaxUrl, {
            requestMethod: 'post',
            requestHeader: 'Content-Type',
            requestHeaderValue: 'application/json;charset=UTF-8',
            requestData: JSON.stringify(jsonData),
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.setResult(results);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    togglePreviewSwitchVisibility () {
        if (!this.$bookmarkPreviewSwitch) return;
        const hasPreviewTeaser = this.$results.querySelector('[data-bookmark-travel-preview="true"]') !== null;
        this.$bookmarkPreviewSwitch.classList.toggle('main-filter__switch-wrapper--hidden', !hasPreviewTeaser);
    }

    setResult (results) {
        const $result = createElementFromHTML(results.html);
        this.$results.style.height = this.$results.scrollHeight + 'px';

        this.$results.innerHTML = '';

        if (this.loader) {
            this.loader.classList.add('is--hidden');
        }

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$results.appendChild(item);
            });
        } else {
            this.$results.appendChild($result);
        }

        this.togglePreviewSwitchVisibility();

        window.dispatchEvent(new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$results
            }
        }));

        window.bookmark.initialize(this.$results);

        setTimeout(() => {
            this.$results.style.height = $result.scrollHeight + 'px';
        }, 50);

        setTimeout(() => {
            this.$results.style.height = 'auto';
            this.ajaxActive = false;

            if (this.loader) {
                this.loader.remove();
                this.loader = null;
            }

            this.pagination.check((action) => {
                this.ajaxUrl = action;
                this.checkBeforeSubmit();
            });
        }, 550);

        const $$dataInview = this.$results.querySelectorAll('[data-inview]:not(.inview)');
        setTimeout(() => {
            $$dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 100);
    }
}

export { BookmarkedTravels };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $bookmarkedTravels = $context.querySelector('[data-bookmark-travels="root"]');

        if ($bookmarkedTravels) {
            const bookmarkedTravels = new BookmarkedTravels($bookmarkedTravels);
            bookmarkedTravels.initialize();
        }
    }
});
